import { Box } from "@mui/material";

import MyPerformanceSummaryCard from "../widgets/MyPerformanceSummary/MyPerformanceSummaryCard";
import SalesRepWidgetTabs from "./SalesRepWidgetTabs";

/**
 * Sales rep–only My Performance body (same route as other roles).
 * Greeting + product filter live in {@link MyPerformanceHeader}.
 */
export default function SalesRepMyPerformanceView({
  summaryProps,
  widgetProps,
  selectedProduct,
}) {
  return (
    <>
      {summaryProps && (
        <Box sx={{ mb: 3 }}>
          <MyPerformanceSummaryCard {...summaryProps} />
        </Box>
      )}

      <SalesRepWidgetTabs
        widgetProps={widgetProps}
        selectedProduct={selectedProduct}
      />
    </>
  );
}
